import { registerPlugin } from '@capacitor/core';
const TapJacking = registerPlugin('TapJacking', {
    web: () => import('./web').then((m) => new m.CapacitorTapJackingWeb()),
});
export * from './definitions';
export { TapJacking };
//# sourceMappingURL=index.js.map